import { Route, Switch } from 'wouter';
import HomePage from './pages/home';
import TasksPage from './pages/tasks';
import TeamPage from './pages/team';
import useUserStore from './store/useUserStore';
import TasksManagementPage from './pages/task-management';
import TaskCalendarPage from './pages/task-calendar';
import MetricsPage from './pages/metrics/MetricsPage';
import CategoryMetricsPage from './pages/metrics/CategoryMetricsPage';
import AskerMetricsPage from './pages/metrics/AskerMetricsPage';
import CommunesMetricsPage from './pages/metrics/CommunesMetricsPage';
import TaskersMetricsPage from './pages/metrics/TaskersMericsPage';
import GenderMetricsPage from './pages/metrics/GenderMetricsPage';
import CompletionMetricsPage from './pages/metrics/CompletionMericsPage';
import TaskerManagementPage from './pages/taskers/TaskerManagementPage';
import PendingTaskerManagementPage from './pages/taskers/PendingTaskerManagementPage';
import CategoryPerTimeblockReport from './pages/metrics/CategoryPerTimeblockReport';
import SalesPerDayReport from './pages/metrics/SalesPerDayReport';
import SalesPerHelperReport from './pages/metrics/SalesPerHelperReport';
import TasksPerCommunePerCategoryReport from './pages/metrics/TasksPerCommunePerCategoryReport';
import TasksPerCommunePerSexReport from './pages/metrics/TasksPerCommunePerSexReport';
import TaskerProfilePage from './pages/tasker/TaskerProfilePage';
import MpPayments from './pages/mp-payments';
import PaymentsPage from './pages/payments';
import TaskersPage from './pages/taskers';
import RecurringTasksPage from './pages/recurring-tasks';
import PostulationsPage from './components/tasks/taskerPostulations/postulationsPage';
import PopupPage from './pages/popup';
import { lazy } from 'react';
import DiscountCouponsPage from './pages/discount-coupons';
import CategoryTopics from './pages/category-topics';
import AutomatedOffersPage from './pages/automated-offers';
import { ROUTES } from './types/api';
import { ROLES } from './types/constans';

const AppBanners = lazy(() => import('./pages/app-banners'));

const RoutesConfig = () => {
  const { userProfile } = useUserStore();

  return (
    <Switch>
      <Route path={ROUTES.HOME_PAGE} component={HomePage} />
      <Route path={ROUTES.TASK} component={TasksPage} />
      <Route path={ROUTES.TASK_MANAGEMENT} component={TasksManagementPage} />
      <Route path={ROUTES.TASK_CALENDAR} component={TaskCalendarPage} />
      <Route path={ROUTES.AUTOMATED_OFFERS} component={AutomatedOffersPage} />

      {/* METRICS START */}
      <Route path={ROUTES.METRICS} component={MetricsPage} />
      <Route path={ROUTES.METRICS_CATEGORIES} component={CategoryMetricsPage} />
      <Route path={ROUTES.METRICS_ASKER} component={AskerMetricsPage} />
      <Route path={ROUTES.METRICS_COMMUNES} component={CommunesMetricsPage} />
      <Route path={ROUTES.METRICS_TASKERS} component={TaskersMetricsPage} />
      <Route path={ROUTES.METRICS_GENDER} component={GenderMetricsPage} />
      <Route path={ROUTES.METRICS_COMPLETION} component={CompletionMetricsPage} />
      {/* TODO Preguntar porque no tiene validaciones de admin ? */}
      <Route path={ROUTES.ADMIN_TASKERS} component={TaskerManagementPage} />
      <Route path={ROUTES.ADMIN_PENDING_TASKERS} component={PendingTaskerManagementPage} />
      <Route path={ROUTES.METRICS_CATEGORY_TIMEBLOCK} component={CategoryPerTimeblockReport} />
      <Route path={ROUTES.METRICS_SALES_PER_DAY} component={SalesPerDayReport} />
      <Route path={ROUTES.METRICS_SALES_PER_HELPER} component={SalesPerHelperReport} />
      <Route
        path={ROUTES.METRICS_TASKS_PER_COMMUNE_PER_CATEGORY}
        component={TasksPerCommunePerCategoryReport}
        />
      <Route path={ROUTES.METRICS_TASKS_PER_COMMUNE_PER_SEX} component={TasksPerCommunePerSexReport} />
      {/* METRICS END */}
      
      <Route path={ROUTES.TASKER_PROFILE} component={TaskerProfilePage} />
      <Route path={ROUTES.TASKERS} component={TaskersPage} />
      
      <Route path={ROUTES.MP_PAYMENTS} component={MpPayments} />
      <Route path={ROUTES.PAYMENTS} component={PaymentsPage} />
      <Route path={ROUTES.RECURRING_TASKS}component={RecurringTasksPage} />
      <Route path={ROUTES.TASK_POSTULATIONS} component={PostulationsPage} />
      <Route path={ROUTES.POPUP} component={PopupPage} />
      <Route path={ROUTES.APP_BANNERS} component={AppBanners} />

      {userProfile?.role.includes(ROLES.ADMIN) && <Route path={ROUTES.TEAM} component={TeamPage} />}
      {userProfile?.role.includes(ROLES.ADMIN) && (
        <Route path={ROUTES.DISCOUNT_COUPONS} component={DiscountCouponsPage} />
      )}

      <Route path={ROUTES.CATEGORY_TOPICS} component={CategoryTopics} />

      {/* Add a catch-all route for unauthorized access */}
      <Route>Not Found</Route>
    </Switch>
  );
};

export default RoutesConfig;
